<template>
  <v-expansion-panel
    class="my-2"
    v-if="isSelected"
  >
    <v-expansion-panel-header>
      <div class="d-flex align-center">
        <h3 class="mr-2">{{ displayLabel }}</h3>
        {{ $t(indicator.nameKey) }}
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <component
        :key="refreshKey"
        :is="chartComponent"
        :filterProp="computedFilterProp"
        :review="computedReview"
        :isResult="false"
        @setInfos="$emit('setInfos', $event)"
        :institution="institution"
        :unidades="unidades"
        v-bind="extraPropsObj"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { getCategoryById } from '../../../indicators/indicatorRegistry'
import { componentMap } from '../../../indicators/indicatorComponents'

export default {
  name: 'IndicatorConfigPanel',

  props: {
    indicator: { type: Object, required: true },
    isEditing: { type: Boolean, default: false },
    chartInfos: { type: Array, default: () => [] },
    selection: { type: Array, default: () => [] },
    institution: { type: Object, default: () => ({}) },
    unidades: { type: Array, default: () => [] },
    standardEquipments: { type: Array, default: () => [] },
    refreshKey: { type: Number, default: 0 },
  },

  computed: {
    isSelected() {
      return this.selection.includes(this.indicator.legacyKey)
    },

    displayLabel() {
      const cat = getCategoryById(this.indicator.categoryId)
      return `${cat.prefix}.${this.indicator.displayNumber}`
    },

    chartInfo() {
      return this.chartInfos.find(
        (x) => x.chart === this.indicator.legacyKey
      )
    },

    computedFilterProp() {
      return this.chartInfo || {}
    },

    computedReview() {
      if (this.chartInfo) {
        return this.chartInfo.review || ''
      }
      return ''
    },

    chartComponent() {
      const loader = componentMap[this.indicator.componentName]
      return loader || null
    },

    extraPropsObj() {
      const props = {}
      if (this.indicator.extraProps.includes('standardEquipments')) {
        props.standardEquipments = this.standardEquipments
      }
      return props
    },
  },
}
</script>
